import './SessionEndConfirmPopup.css';
import React from 'react';
import { useTranslations } from '../../hooks/use-translations.hook';
import { useDispatch } from 'react-redux';
import { useAsgActions } from '../../hooks/use-asg-actions.hook';

export const SessionEndConfirmPopup = ({
    className = '',
    gameId,
    gameName,
    onConfirmClickHandler = () => {},
    closeGamesList = () => { },
    cancelScheduledClose = () => { }
}) => {
    const { t } = useTranslations();
    const dispatch = useDispatch();
    const { closeAndLoadGame, fillGameSwitchInProgress } = useAsgActions();

    const openGame = (e) => {
        onConfirmClickHandler(e);

        // this will prevent gameClose event from closing embedded game
        dispatch(fillGameSwitchInProgress(true));

        // open next game
        dispatch(closeAndLoadGame({
            gameId: gameId,
        }));
    };

    return (
        <div className={`${className} session-end-confirm-popup`}
            onMouseEnter={cancelScheduledClose}
            onMouseLeave={closeGamesList}
        >
            <div className="session-end-confirm-popup__header">{t('gameSessionWillEnd')}</div>
            <div
                className="session-end-confirm-popup__cta"
                onClick={openGame}
            >{t('takeMeTo')} {gameName}</div>
        </div>
    );
};
